import axios from 'axios'
import router from '../router'
// axios.defaults.baseURL = '/app'
axios.defaults.baseURL=process.env.BASE_API
// let host = 'https://www.tyouke.com'
let host = 'https://www.kwinli.cn' //金永历

// let host='https://tccs.59156.cn'//测试

// 获取首页信息
export const getindex = params => {
  return axios.post(`${host}/app/member/index`, params)
}

// 获取登录
export const getLogin = params => {
  return axios.post(`${host}/app/account/login`, params)
}

// 获取注册
export const getRegister = params => {
  return axios.post(`${host}/app/account/register`, params)
}

// 获取微信授权
export const getWxcode = params => {
  return axios.post(`${host}/app/account/wx_code_url`, params)
}
export const getWxinfo = params => {
  return axios.post(`${host}/app/account/wx_userinfo`, params)
}
export const getWxUser = params => {
  return axios.post(`${host}/app/account/wx_user_subscribe`, params)
}

// 会员等级
export const getGrade = params => {
  return axios.post(`${host}/app/member/grade`, params)
}

//积分
export const getScore = params => {
  return axios.post(`${host}/app/member/bill`, params)
}

//积分详情
export const getScoreD = params => {
  return axios.post(`${host}/app/appindex/rule`, params)
}

//品牌介绍
export const getBrand = params => {
  return axios.post(`${host}/app/home/merchant`, params)
}

//积分商城
export const getShop = params => {
  return axios.post(`${host}/app/score/index`, params)
}

//积分商城详情
export const getShopD = params => {
  return axios.post(`${host}/app/score/details`, params)
}

//积分兑换
export const getExchange = params => {
  return axios.post(`${host}/app/score/add_exchange`, params)
}
export const getExchangeInfo = params => {
  return axios.post(`${host}/app/score/exchange_info`, params)
}

//积分兑换详情
export const getOrder = params => {
  return axios.post(`${host}/app/score/order_details`, params)
}

//积分兑换列表
export const getOrderList = params => {
  return axios.post(`${host}/app/score/order_list`, params)
}

//优惠券
export const getTicket = params => {
  return axios.post(`${host}/app/member/ticket_list`, params)
}

//优惠券详情
export const getTicketD = params => {
  return axios.post(`${host}/app/member/ticket_details`, params)
}
export const getTicketD1 = params => {
  return axios.post(`${host}/app/appindex/ticket_details`, params)
}

//电子质保单
export const getMerchant = params => {
  return axios.post(`${host}/app/order/merchant_order`, params)
}

//电子质保单详情
export const getMerchantD = params => {
  return axios.post(`${host}/app/order/merchantOrder_details`, params)
}

//营销活动
export const getActivity = params => {
  return axios.post(`${host}/app/activity/index`, params)
}

//营销活动详情
export const getActivityD = params => {
  return axios.post(`${host}/app/activity/details`, params)
}

//用户抽奖获取中奖商品
export const getRollGoods = params => {
  return axios.post(`${host}/app/activity/roll_goods`, params)
}

//游客抽奖获取中奖商品
export const getRoll = params => {
  return axios.post(`${host}/app/activity/roll`, params)
}

//游客领取商品
export const getLqGoods = params => {
  return axios.post(`${host}/app/activity/lq_award`, params)
}

//奖品列表
export const getUserAward = params => {
  return axios.post(`${host}/app/activity/user_award`, params)
}

//分享机会
export const getShare = params => {
  return axios.post(`${host}/app/activity/share_activity`, params)
}

//分享
export const getSignPackage = params => {
  return axios.post(`${host}/app/wechat/getSignPackage`, params)
}

//微信支付
export const getWxPay = params => {
  return axios.post(`${host}/app/activity/wx_pays`, params)
}

//创建支付订单
export const getCreate = params => {
  return axios.post(`${host}/app/activity/create_act_order`, params)
}

//创建订单
export const getBlind = params => {
  return axios.post(`${host}/app/activity/create_blind`, params)
}

//投票(预定)
export const getVote = params => {
  return axios.post(`${host}/app/activity/vote_details`, params)
}

//领取商品详情
export const getAwardD = params => {
  return axios.post(`${host}/app/activity/award_details`, params)
}

//投票
export const getVoteD = params => {
  return axios.post(`${host}/app/activity/vote`, params)
}

//友情券转赠
export const getyqCoupon = params => {
  return axios.post(`${host}/app/account/yq_ticket_zz`, params)
}

//软件介绍
export const getSoftware = params => {
  return axios.post(`${host}/app/appindex/content`, params)
}

//绑定会员
export const getBindworker = params => {
  return axios.post(`${host}/app/appindex/bind_worker`, params)
}

//获取卡包信息(未注册)
export const getCard = params => {
  return axios.post(`${host}/app/account/get_card`, params)
}

//获取卡包信息
export const getAddCard = params => {
  return axios.post(`${host}/app/account/add_card`, params)
}

//质保单
export const getView = params => {
  return axios.post(`${host}/app/appindex/qa_view`, params)
}

//联盟券
export const getLeague = params => {
  return axios.post(`${host}/app/account/get_league_ticket`, params)
}

//获取头像
export const getHead = params => {
  return axios.post(`${host}/app/member/update_wx_head`, params)
}

//获取海报二维码
export const getHbCode = params => {
  return axios.post(`${host}/app/activity/activity_code`, params)
}

//抽奖（新）
export const getNewPrize = params => {
  return axios.post(`${host}/app/activity/new_roll_goods`, params)
}

//用户领取新）
export const getNewLq = params => {
  return axios.post(`${host}/app/activity/new_lq_award`, params)
}

//
export const getNewTicket = params => {
  return axios.post(`${host}/app/account/ticket_details`, params)
}

//获取门店列表
export const getStoreList = params => {
  return axios.post(`${host}/app/appindex/merchant_list`, params)
}


//确定选择的门店
export const saveStoreChoose = params => {
  return axios.post(`${host}/app/appindex/merchant_save`, params)
}

//是否弹出导购二维码
export const closeWorkerPop = params => {
  return axios.post(`${host}/app/member/close_worker_pop`, params)
}
export const activityHb = params => {
  return axios.post(`${host}/app/activity/activity_hb`, params)
}





// WEBPACK FOOTER //
// ./src/api/api.js